import { render, staticRenderFns } from "./PrintInCode4.vue?vue&type=template&id=67da7862&scoped=true"
import script from "./PrintInCode4.vue?vue&type=script&lang=js"
export * from "./PrintInCode4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67da7862",
  null
  
)

export default component.exports